import { createClient } from '@supabase/supabase-js';

// Lê as variáveis de ambiente do Expo ou do React App
const url = process.env.EXPO_PUBLIC_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL;
const key = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY;

// 🛡️ Blindagem: Se falhar, avisa e trava antes de causar tela branca
if (!url || !key) {
  console.error("🚨 ALERTA CRÍTICO: Variáveis do .env não foram lidas. Verifique o arquivo .env ou as variáveis na Vercel.");
  throw new Error("Falha na inicialização do cliente: Credenciais do banco de dados ausentes.");
}

// O TypeScript agora sabe que url e key são strings garantidas
export const supabase = createClient(url, key);